import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { Reveal, SectionHead } from "../components/Reveal";
import Seo from "../components/Seo";
import { SiteMarquee } from "../components/SiteMarquee";
import { SERVICES } from "../data";

const STEPS = [
  { n: "01", title: "Sopralluogo Gratuito", desc: "Analizziamo gli spazi e ascoltiamo le tue esigenze, senza impegno." },
  { n: "02", title: "Progetto & Preventivo", desc: "Preventivo dettagliato con tempi, materiali e costi chiari." },
  { n: "03", title: "Cantiere Gestito", desc: "Un unico referente coordina tutte le maestranze, sempre." },
  { n: "04", title: "Consegna & Garanzia", desc: "Collaudo finale, certificazioni e garanzia su ogni lavorazione." },
];

export default function Servizi() {
  return (
    <main data-testid="servizi-page" className="pt-20">
      <Seo
        title="Servizi Edili e Impianti | Edilkrea Technoimpianti"
        description="Ristrutturazioni chiavi in mano, impianti tecnologici e domotica, nuove costruzioni ed efficientamento energetico. Scopri come lavoriamo."
      />
      <section className="mx-auto max-w-7xl px-5 sm:px-8 pt-16 sm:pt-24 pb-8">
        <SectionHead level="h1" overline="I Nostri Servizi" title="Soluzioni Chiavi in Mano" />
        <Reveal delay={0.15}>
          <p className="mt-6 max-w-2xl text-base sm:text-lg text-slate-300 leading-relaxed">
            Dalla progettazione strutturale all'impiantistica tecnologica avanzata:
            ogni intervento è seguito con la stessa cura, dal primo sopralluogo alla consegna delle chiavi.
          </p>
        </Reveal>
      </section>

      <SiteMarquee />

      <section className="mx-auto max-w-7xl px-5 sm:px-8 py-20 sm:py-28 space-y-20 sm:space-y-28">
        {SERVICES.map((s, i) => (
          <Reveal key={s.id} className="grid items-center gap-8 lg:grid-cols-2 lg:gap-14">
            <div className={`${i % 2 === 1 ? "lg:order-2" : ""} group relative overflow-hidden rounded-2xl border border-gold/15`}>
              <img
                src={s.image}
                alt={s.title}
                className="h-72 sm:h-96 w-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-ink/70 to-transparent" />
              <span className="absolute top-5 left-5 rounded-full bg-ink/70 backdrop-blur px-4 py-1.5 font-mono text-[11px] uppercase tracking-[0.25em] text-gold border border-gold/20">
                {s.tag}
              </span>
            </div>
            <div>
              <span className="font-display text-5xl font-extrabold text-stroke-gold">{String(i + 1).padStart(2, "0")}</span>
              <h2 className="mt-4 font-display text-2xl sm:text-4xl font-bold uppercase leading-tight text-cream" data-testid={`service-title-${s.id}`}>
                {s.title}
              </h2>
              <p className="mt-5 text-base sm:text-lg text-slate-300 leading-relaxed">{s.description}</p>
              <ul className="mt-6 space-y-3">
                {s.points.map((p) => (
                  <li key={p} className="flex items-center gap-3 text-sm text-slate-300">
                    <span className="flex h-6 w-6 items-center justify-center rounded-full bg-copper/15 border border-copper/30">
                      <Check className="h-3.5 w-3.5 text-copper" />
                    </span>
                    {p}
                  </li>
                ))}
              </ul>
              <Link
                to="/contatti"
                data-testid={`service-quote-${s.id}`}
                className="group mt-8 inline-flex items-center gap-2 rounded-full border border-gold/30 px-6 py-3 text-sm font-semibold uppercase tracking-wider text-gold transition-all hover:bg-gold hover:text-ink hover:-translate-y-0.5"
              >
                Richiedi questo servizio
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
              </Link>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="border-t border-gold/10 bg-panel py-20 sm:py-28" data-testid="servizi-process">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
          <SectionHead overline="Come Lavoriamo" title="Il Nostro Metodo" />
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {STEPS.map((st, i) => (
              <Reveal key={st.n} delay={i * 0.08}>
                <div className="h-full rounded-2xl border border-gold/15 bg-card2 p-6 transition-colors hover:border-gold/40">
                  <span className="font-display text-3xl font-extrabold text-copper">{st.n}</span>
                  <h3 className="mt-4 font-display text-lg font-bold uppercase text-cream">{st.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-slate-400">{st.desc}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
}
